import { render, staticRenderFns } from "./noticeDetail.vue?vue&type=template&id=02a1e7bd&scoped=true&"
import script from "./noticeDetail.vue?vue&type=script&lang=js&"
export * from "./noticeDetail.vue?vue&type=script&lang=js&"
import style0 from "./noticeDetail.vue?vue&type=style&index=0&id=02a1e7bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a1e7bd",
  null
  
)

export default component.exports